module.exports = __webpack_public_path__ + "static/media/Group 3.1a237ab4.png";